import React , { useState } from 'react'

import * as XLSX from 'xlsx'

import { ApiCallPost } from '../../ApiCall/ApiCall';


export default function Promos() {

    const [data, setData] = useState([]); // Son los datos que se llen de xml

    function onCargarDatos()
    {
        console.log( "onCargarDatos")

        ApiCallPost("cargapromo", data ) // cargapromo
        .then( (response) => {
            console.log( "response = " + response)
        })
        .catch( (error) => {
            console.log( "error = " + error)
        })

    }

    function handleUpload(e) {
        e.preventDefault();
    
        console.log( "handleUpload")
    
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = function (e) {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
    
            console.log( "Length = " + jsonData.length)
            console.log(jsonData);

            setData(jsonData);


        };
        reader.readAsArrayBuffer(file);
    }
    

  return (
    <div>

        <div className='excel'>

        <label >Carga Promociones &nbsp;</label>



        <input type='file' accept='.xlsx,.xls,.ods' onChange={handleUpload}>
        </input>

        {
            data.length > 0 && (
                <button type='button' onClick={onCargarDatos}>Cargar datos</button>
            )
        }
        </div>
                
    </div>
  )
}
